import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";


@Injectable()
export class IdiomaService {

  private selectedLanguage$ = new BehaviorSubject<string>('es'); // 'es' como valor inicial

  changeSelectedLanguage(lang: string) {
    this.selectedLanguage$.next(lang);
  }

  getSelectedLanguage$(): Observable<string> {
    return this.selectedLanguage$.asObservable();
  }

  get selectedLanguage(): string {
    return this.selectedLanguage$.value; // Obtener el valor actual directamente
  }
}
